export { default as FreeShippingText } from './freeShippingText'



// WEBPACK FOOTER //
// ./src/modules/persistent-cart/freeShippingText/index.js